import { saveListReturnUrl } from '@redpanda/utils';

/**
 * 商機記住上次用列表還是看板（主流做法，例：Jira、HubSpot）：側欄「商機」連到上次的檢視
 * 存在這台瀏覽器的 localStorage（換帳號時會清掉）；讀寫失敗時就是列表
 */
const KEY = 'crm-ui:opportunity.view';
const KANBAN_PATH = '/opportunities/kanban';

/** 列表、看板頁打開時呼叫；看板也記成「回到商機列表」的網址，詳情頁麵包屑回到看板 */
export const rememberOpportunityView = (view: 'list' | 'kanban') => {
  try {
    localStorage.setItem(KEY, view);
  } catch { /* localStorage 不可用時只是不記住 */ }
  if (view === 'kanban') saveListReturnUrl('/opportunities', KANBAN_PATH);
};

/** 側欄「商機」的連結：人在列表或看板時就是目前的檢視（頁面記住的值要等 effect 才寫入），其他頁面用記住的 */
export const opportunityHomePath = (pathname: string) => {
  if (pathname === '/opportunities' || pathname === KANBAN_PATH) return pathname;
  try {
    return localStorage.getItem(KEY) === 'kanban' ? KANBAN_PATH : '/opportunities';
  } catch {
    return '/opportunities';
  }
};
